export enum DraggableType {
    Stage = 'Stage',
    Filter = 'Filter',
}